import { Advantage } from '../models/advantage.model';

export const ADVANTAGES: Advantage[] = [
  {
    'fileName': 'advantage-01.png',
    'alt': '藤途的产品体系',
    'routerLink': '',
    'contents': [
      '联合名企大咖',
      '研发专业项目',
      '以走进名企为目标'
    ]
  },
  {
    'fileName': 'advantage-02.png',
    'alt': '国际化的实操体验',
    'routerLink': '',
    'contents': [
      '就职于海外名企',
      '专业背景',
      '更有名企HR手把手',
      '带你加入名企直通车'
    ]
  },
  {
    'fileName': 'advantage-03.png',
    'alt': '藤途的教育体系',
    'routerLink': '',
    'contents': [
      '电子教务管理',
      '从面试-求学规划',
      '-求职规划-海外生活的',
      '一站式服务',
      '全程追踪',
      '独立文档',
      '进度跟进'
    ]
  },
  {
    'fileName': 'advantage-04.png',
    'alt': '350+导师',
    'routerLink': '',
    'contents': [
      '来自名企的大神带领团队',
      '专业的企业案例分析',
      '注重多元化实操体验'
    ]
  }
];



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/data/advantages.ts